import {useNavigation} from '@react-navigation/native';
import React from 'react';

import {Button, ButtonProps} from '../../components/Button';
import {Screens} from '../../constants/navigation';
import type {RootStackScreenProps} from '../../navigators/RootStackNavigator';
import {RedirectOptions, RedirectionParameter} from '../../navigators/params';

export interface RedirectButtonProps extends ButtonProps {
  redirect?: RedirectOptions;
}

type Navigation = RootStackScreenProps<typeof Screens.Register>['navigation'];

export const RedirectButton = ({
  redirect,
  onPress,
  ...rest
}: RedirectButtonProps) => {
  const navigation = useNavigation<Navigation>();

  return (
    <Button
      variant="transparent"
      onPress={
        onPress ??
        (() => {
          if (!redirect) return;

          navigation.navigate(...RedirectionParameter.decode(redirect));
        })
      }
      {...rest}
    />
  );
};
